import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuditCollectionResult } from 'src/app/core-module/models/Audits/audit-collection-result';
import { BasicAuditReturn } from 'src/app/core-module/models/Audits/AuditResults/basic-audit-return';
import { BasicUser } from 'src/app/core-module/models/basic-user';
import { ActionFilters } from 'src/app/core-module/models/Compliance-Actions/action-filters';
import { ActionFiltersResult } from 'src/app/core-module/models/Compliance-Actions/action-filters-result';
import { ActionHolder } from 'src/app/core-module/models/Compliance-Actions/action-holder';
import { ActionListRequest } from 'src/app/core-module/models/Compliance-Actions/action-list-request';
import { Action } from 'src/app/core-module/models/Compliance-Actions/action';
import { ActionResult } from 'src/app/core-module/models/Compliance-Actions/action-result';
import { ActionUserRequest } from 'src/app/core-module/models/Compliance-Actions/action-user-request';
import { DDL } from 'src/app/core-module/models/ddl';
import { AuditLocation } from 'src/app/core-module/models/Locations/audit-location';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { ComplianceActionService } from 'src/app/core-module/services/compliance-action.service';
import { ExportService } from 'src/app/core-module/services/export.service';
import { ReferenceService } from 'src/app/core-module/services/reference.service';
import { UserService } from 'src/app/core-module/services/user.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { CompactActionPanelComponent } from '../home/action-panel/compact-action-panel.component';
import { ProgramFeatures } from 'src/app/core-module/models/UserManagement/program-features';
import { CustomerContextService } from 'src/app/core-module/services/customer-context.service';

@Component({
    selector: 'app-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActionsComponent {
  private readonly customerContext = inject(CustomerContextService);


  includeComplete: boolean = false;
  overdueonly: boolean = false;

  public showFilters: boolean = true;
  public returnedAudits: AuditCollectionResult = new AuditCollectionResult;
  public auditDDLList: DDL[] = [];
  public selectedAuditDDL: DDL = new DDL();


  public selectedAudit: BasicAuditReturn = new BasicAuditReturn();
  public selectedFrequency: DDL = new DDL();
  private _frequencies: DDL[] = [];
  public frequencies: DDL[] = [];
  private _locations: AuditLocation[] = []
  public locations: AuditLocation[] = [];
  public locationGroups: { label: string; items: AuditLocation[] }[] = [];
  public locationGroupsWithAll: { label: string; items: AuditLocation[] }[] = [];
  public useLocationGroups: boolean = false;
  public selectedLocation: AuditLocation = new AuditLocation();
  public selectedAuditType: DDL = new DDL();
  public auditTypes: DDL[] = [];
  private auditList: BasicAuditReturn[] = [];
  public displayAudits: BasicAuditReturn[] = [];
  public users: BasicUser[] = [];
  public selectedUser: BasicUser = new BasicUser();


  public IncludeSubLocations: boolean = false;


  public returnedUsers: BasicUser[] = [];

  public startDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 3));
  public endDate: Date = new Date();

  public isLoading: boolean = false;



  private request: ActionListRequest = new ActionListRequest({ StartDate: this.startDate, EndDate: this.endDate, AuditID: -1, LocationID: -1, AuditorUserID: -1, IncludeSublocations: this.IncludeSubLocations, ActionTypeID: 1 })

  public totalActionCount: number = 0;
  public totalOverdueActionCount: number = 0;
  public totalDueActionCount: number = 0;
  public totalResolvedCount: number = 0;
  public totalActionsNotDueCount: number = 0;
  public showResolvedCount: boolean = false;
  public totalResultCount: number = 0;
  public pageNumber: number = 1;
  public pageSize: number = 100;
  public firstResult: number = 0;
  public pageSizeOptions: number[] = [25, 50, 100];
  public actionPagingAvailable: boolean = false;
  actionList: ActionResult = new ActionResult();
  private incomingFilters: any = null;
  public filterStateParam: string = '';
  public showAdvancedFilters: boolean = false;

  public showActionSummary: boolean = false;
  public summaryHasComments: boolean = false;
  public summaryHasReference: boolean = false;
  public summaryActions: Action[] = [];
  public canShowActionSummary: boolean = false;

  constructor(private auth: AuthService, private router: Router, public actionService: ComplianceActionService, private refService: ReferenceService, private auditService: AuditService, private userHelperService: UserService, private exportService: ExportService, private util: UtilService) { }
  expandAll: boolean = false;

  ngOnInit() {
    const filters = this.router.routerState.snapshot.root.queryParams['filters'];
    if (filters){
      try{
        this.incomingFilters = JSON.parse(decodeURIComponent(filters));
      }catch{}
    }
    this.auth.getFeaturePermissions().pipe(
      tap((res: ProgramFeatures) => {
        if (!res?.IsError) {
          this.canShowActionSummary = !!res.ActionSummary;
        }
      })
    ).subscribe();
    this.getActionFilters();
  }


  getActionFilters() {
    this.actionService.getActionFilters().pipe(tap((res:ActionFiltersResult) => {
      if (!res.IsError) {
        this.setFilters(res.Filters);
        this.applyIncomingFilters();
        this.updateRequest();
        this.updateFilterParam();
        this.getActionData();
      }

    })).subscribe()
  }
  setFilters(filters: ActionFilters) {
    this.auditTypes = [];
    this.auditTypes.push(new DDL({ ID: -1, Description: this.customerContext.displayText("All Audit Types") }));
    this.selectedAuditType = this.auditTypes[0];
    if (filters.AuditTypes.length > 0) {
      filters.AuditTypes.forEach(e => {
        this.auditTypes.push(new DDL(e));
      });
    }
    this._frequencies = [];
    this._frequencies.push(new DDL({ ID: -1, Description: this.customerContext.displayText("All Audit Frequencies") }));
    if (filters.Frequencies.length > 0) {
      filters.Frequencies.forEach(e => {
        this._frequencies.push(new DDL(e));
      });
    }
    this.setFrequencies(false);
    this.selectedFrequency = this._frequencies[0];
    /*if (filters.Frequencies.length > 0) {
      filters.Frequencies.forEach(e => {
        this.Frequencies.push(new DDL(e));
      });
    }*/
    this.auditList = [];
    this.auditList.push(new BasicAuditReturn({ AuditID: -1, AuditName: this.customerContext.displayText("All Audits") }))
    this.selectedAudit = this.auditList[0];
    if (filters.Audits.length > 0) {
      filters.Audits.forEach(e => {
        this.auditList.push(new BasicAuditReturn(e));
      })
      this.updateAudits();
    }
    const allLocations = new AuditLocation({ LocationID: -1, LocationName: "All Locations" });
    const locationBuild = this.buildActionLocations(filters.Locations || []);
    this.locations = [allLocations, ...locationBuild.locations];
    this.locationGroups = locationBuild.groups;
    this.useLocationGroups = locationBuild.useGroups;
    this.locationGroupsWithAll = this.useLocationGroups
      ? [{ label: '', items: [allLocations] }, ...this.locationGroups]
      : [];
    this.selectedLocation = this.locations[0];
    this.users = [];
    const allUsers = new BasicUser({UserID:-1,DisplayName:"All Users"});
    if(filters.ActionUsers.length>0){
      filters.ActionUsers.forEach(e=>{
        this.users.push(new BasicUser(e));
      })
    }
    const isGroup = (u: BasicUser) => u.UserTypeID === 2;
    this.users = this.users
      .filter(u => u.UserID !== -1)
      .sort((a, b) => {
        const aIsGroup = isGroup(a);
        const bIsGroup = isGroup(b);
        if (aIsGroup !== bIsGroup) {
          return aIsGroup ? -1 : 1;
        }
        return a.DisplayName.localeCompare(b.DisplayName);
      });
    this.users.unshift(allUsers);
    this.selectedUser = this.users[0];
  }

  private buildActionLocations(locations: AuditLocation[]): {
    locations: AuditLocation[];
    groups: { label: string; items: AuditLocation[] }[];
    useGroups: boolean;
  } {
    if (!locations || locations.length === 0) {
      return { locations: [], groups: [], useGroups: false };
    }
    const normalized = locations.map(l => {
      const loc = new AuditLocation(l);
      if (!loc.LocationLevelSeq || loc.LocationLevelSeq === -1) {
        loc.LocationLevelSeq = 1;
      }
      return loc;
    });
    const nameCompare = (a: AuditLocation, b: AuditLocation) =>
      a.LocationName.localeCompare(b.LocationName, undefined, { sensitivity: 'base' });
    const levelSeqs = Array.from(new Set(normalized.map(l => l.LocationLevelSeq))).sort((a, b) => a - b);
    if (levelSeqs.length <= 1) {
      return {
        locations: normalized.sort(nameCompare),
        groups: [],
        useGroups: false
      };
    }
    const levelMap = new Map<number, number>();
    levelSeqs.forEach((seq, index) => {
      levelMap.set(seq, index + 1);
    });
    normalized.forEach(l => {
      l.LocationLevelDisplay = levelMap.get(l.LocationLevelSeq) ?? 1;
    });
    const sorted = normalized.sort((a, b) => {
      const levelDiff = (a.LocationLevelDisplay ?? 1) - (b.LocationLevelDisplay ?? 1);
      if (levelDiff !== 0) {
        return levelDiff;
      }
      return nameCompare(a, b);
    });
    const groups: { label: string; items: AuditLocation[] }[] = [];
    let currentLevel = -1;
    let currentGroup: { label: string; items: AuditLocation[] } | null = null;
    for (const loc of sorted) {
      const displayLevel = loc.LocationLevelDisplay ?? 1;
      if (displayLevel !== currentLevel) {
        currentGroup = { label: `Level ${displayLevel}`, items: [] };
        groups.push(currentGroup);
        currentLevel = displayLevel;
      }
      currentGroup?.items.push(loc);
    }
    return {
      locations: normalized,
      groups,
      useGroups: true
    };
  }
  applyIncomingFilters(){
    if (!this.incomingFilters){ return; }
    const f = this.incomingFilters;
    if (f.useDefaults){
      return;
    }
    if (f.includeResolved !== undefined){ this.includeComplete = !!f.includeResolved; }
    if (f.overdueonly !== undefined){ this.overdueonly = !!f.overdueonly; }
    if (f.includeSubLocations !== undefined){ this.IncludeSubLocations = !!f.includeSubLocations; }
    if (f.startDate){ this.startDate = new Date(f.startDate); }
    if (f.endDate){ this.endDate = new Date(f.endDate); }
    if (f.auditId !== undefined){
      const match = this.auditList.find(a => a.AuditID === f.auditId);
      if (match){ this.selectedAudit = match; }
    }
    if (f.locationId !== undefined){
      const match = this.locations.find(l => l.LocationID === f.locationId);
      if (match){ this.selectedLocation = match; }
    }
    if (f.auditorUserId !== undefined){
      const match = this.users.find(u => u.UserID === f.auditorUserId);
      if (match){ this.selectedUser = match; }
    }
    if (f.auditTypeId !== undefined){
      const match = this.auditTypes.find(t => t.ID === f.auditTypeId);
      if (match){ this.selectedAuditType = match; }
    }
    if (f.frequencyId !== undefined){
      const match = this.frequencies.find(fr => fr.ID === f.frequencyId);
      if (match){ this.selectedFrequency = match; }
    }
  }
  setFrequencies(restricted: boolean) {
    this.frequencies = [];
    this._frequencies.forEach(e => {
      if (restricted) {
        if (e.ID != 1 && e.ID != 4) {
          this.frequencies.push(e)
        }

      } else {
        this.frequencies.push(e)
      }

    });
    if (this.frequencies.findIndex(e => e.ID == this.selectedFrequency.ID) == -1) {
      this.selectedFrequency = this.frequencies[0];
    }

  }

  updateAudits() {
    this.auditList.forEach(e => {
      e.Display = true;
    })
    if (this.selectedAuditType.ID != -1) {
      this.auditList.forEach(e => {
        if (e.AuditID != -1) {
          if (e.AuditType.ID != this.selectedAuditType.ID) {
            e.Display = false;
          }
        }

      })
    }
    if (this.selectedFrequency.ID != -1) {
      this.auditList.forEach(e => {
        if (e.AuditID != -1) {
          if (e.AuditFrequency.ID != this.selectedFrequency.ID) {
            e.Display = false;
          }
        }
      })
    }
    this.displayAudits = this.auditList.filter(e => e.Display);
    if (this.displayAudits.findIndex(e => { e.AuditID != this.selectedAudit.AuditID }) == -1) {
      this.selectedAudit = this.displayAudits[0];
    }
  }
  removeStartDateTimeZone(event: Date) {
    const localDate = this.util.removeTimezoneFromDate(event)
    this.startDate = localDate;
  }
  removeEndDateTimeZone(event: Date) {
    const localDate2 = this.util.removeTimezoneFromDate(event)
    this.endDate = localDate2;
  }
  getActionData() {
    this.isLoading = true;
    this.actionService.getPagedCurrentActions(this.request).pipe(
      tap((res:ActionResult) => {
        if (res.IsError) {
          //Error here
        } else {
          this.actionList = res;
          this.actionPagingAvailable = res.PageSize > 0;
          this.totalResultCount = this.actionPagingAvailable ? res.TotalCount : res.Actions.length;
          this.applyActionTotals(res);
          if (this.showActionSummary) {
            this.buildActionSummary();
          }
        }
        this.isLoading = false;
      })
    ).subscribe();
  }
  updateRequest() {
    this.request = new ActionListRequest({
      IncludeResolved: this.includeComplete,
      StartDate: this.startDate,
      EndDate: this.endDate,
      AuditID: this.selectedAudit.AuditID,
      LocationID: this.selectedLocation.LocationID,
      AuditorUserID: this.selectedUser.UserID,
      AuditTypeID:this.selectedAuditType.ID,
      AuditFrequencyID:this.selectedFrequency.ID,
      OverdueOnly: this.overdueonly,
      IncludeSublocations: this.IncludeSubLocations,
      ActionTypeID: 1,
      PageNumber: this.pageNumber,
      PageSize: this.pageSize

    })
    this.updateFilterParam();
  }
  private updateFilterParam(){
    const payload = {
      includeResolved: this.includeComplete,
      startDate: this.startDate?.toISOString(),
      endDate: this.endDate?.toISOString(),
      auditId: this.selectedAudit?.AuditID ?? -1,
      locationId: this.selectedLocation?.LocationID ?? -1,
      auditorUserId: this.selectedUser?.UserID ?? -1,
      auditTypeId: this.selectedAuditType?.ID ?? -1,
      frequencyId: this.selectedFrequency?.ID ?? -1,
      overdueonly: this.overdueonly,
      includeSubLocations: this.IncludeSubLocations,
      useDefaults: false
    };
    this.filterStateParam = encodeURIComponent(JSON.stringify(payload));
  }
  countActions() {
    this.totalActionCount = 0;
    this.totalDueActionCount = 0;
    this.totalOverdueActionCount = 0;
    this.totalResolvedCount = 0;
    this.totalActionsNotDueCount = 0;
    if (this.includeComplete) {
      this.showResolvedCount = true;
    } else {
      this.showResolvedCount = false;
    }
    this.actionList.Actions.forEach(e => {
      this.totalActionCount++;
      if (e.Resolved) {
        this.totalResolvedCount++;
        return;
      }
      if (this.hasDeadlinePassed(e.ActionDeadline)) {
        this.totalOverdueActionCount++;
        return;
      }
      if (this.isDeadlineDue(e.ActionDeadline)) {
        this.totalDueActionCount++;
        return;
      }
      this.totalActionsNotDueCount++;
    })
  }

  private applyActionTotals(res: ActionResult) {
    const hasServerSummary = this.actionPagingAvailable && (res.TotalCount > 0 || res.Summary.TotalActions > 0);
    if (!hasServerSummary) {
      this.countActions();
      return;
    }

    this.showResolvedCount = this.includeComplete;
    this.totalActionCount = res.Summary.TotalActions;
    this.totalOverdueActionCount = res.Summary.OverdueActions;
    this.totalDueActionCount = res.Summary.DueActions;
    this.totalActionsNotDueCount = res.Summary.NotDueActions;
    this.totalResolvedCount = res.Summary.ResolvedActions;
  }

  hasDeadlinePassed(deadline: Date): boolean {
    if (this.util.stripTime(deadline) < this.util.stripTime(new Date())) {
      return true;
    };
    return false;
  }
  isDeadlineDue(deadline: Date): boolean {

    if (this.util.stripTime(deadline).toString() == this.util.stripTime(new Date()).toString()) {
      return true;
    };
    return false;
  }

  refreshActionData() {
    this.updateRequest();
    this.getActionData();
  }
  refreshSearch() {
    this.pageNumber = 1;
    this.firstResult = 0;
    this.updateRequest();
    this.getActionData();
  }
  onActionsPageChange(event: any) {
    this.firstResult = event.first || 0;
    this.pageSize = event.rows || this.pageSize;
    this.pageNumber = Math.floor(this.firstResult / this.pageSize) + 1;
    this.updateRequest();
    this.getActionData();
  }
  unhideFilters() {
    this.showFilters = !this.showFilters;
  }
  /*getValidLocation() {
    this.refService.getFlatLocationsForUser().pipe(
      tap(res => {
        if (res != null) {
          this.returnedLocations = res
          this.buildLocations();
        }
      })
    ).subscribe();
  }*/
  /*buildLocations() {
    this.locations = [];
    this.locations.push(new DDL({ ID: -1, Description: "All Locations" }));
    this.returnedLocations.forEach(e => {
      this.locations.push(new DDL({ ID: e.LocationID, Description: e.LocationName }));
    })
    this.selectedLocation = this.locations[0];
  }*/
  getAuditFilter() {
    this.auditService.getAudits().pipe(
      tap((res:AuditCollectionResult) => {
        if (res != null) {
          this.returnedAudits = res
          this.buildAuditFilter();
        }
      })
    ).subscribe();
  }
  buildAuditFilter() {
    this.auditDDLList = [];

    this.returnedAudits.Audits.forEach(e => {
      this.auditDDLList.push(new DDL({ ID: e.AuditID, Description: e.AuditName }));
    })
    this.auditDDLList = this.auditDDLList.sort((a, b) => {
      if (a.Description > b.Description) {
        return 1;
      }

      if (a.Description < b.Description) {
        return -1;
      }

      return 0;
    })
    this.auditDDLList.unshift(new DDL({ ID: -1, Description: this.customerContext.displayText('All Audits') }));
    this.selectedAuditDDL = this.auditDDLList[0];
  }
  /*getAuditorData() {
    this.returnedUsers = [];
    var AUR = new ActionUserRequest();
    this.actionService.getActionUsers(AUR).pipe(
      tap(res => {
        this.returnedUsers = res;
        this.returnedUsers = this.userHelperService.sortUsers(this.returnedUsers);
        this.buildAuditorList();
      })
    ).subscribe();
  }*/
  /*buildAuditorList() {
    this.users = [];
    this.users.push(new DDL({ ID: -1, Description: 'All Action Owners' }));
    this.returnedUsers.forEach(e => {
      var bold = false;
      if (e.UserTypeID == 2) {
        bold = true;
      }
      if (this.users.findIndex(f => { return f.ID == e.UserID }) == -1) {

        this.users.push(new DDL({ ID: e.UserID, Description: e.DisplayName, Bold: bold }));
      }
    })
    this.selectedUserDDL = this.users[0];
  }*/

  displayDate(date: Date): string {
    return this.util.humanDate(date);
  }

  showActionSummaryView() {
    if (!this.canShowActionSummary) {
      return;
    }
    this.isLoading = true;
    const summaryRequest = new ActionListRequest({ ...this.request, PageNumber: 1, PageSize: 0 });
    this.actionService.getCurrentActions(summaryRequest).pipe(
      tap((res: ActionResult) => {
        if (!res.IsError) {
          this.buildActionSummary(res.Actions);
          this.showActionSummary = true;
        }
        this.isLoading = false;
      })
    ).subscribe();
  }

  hideActionSummary() {
    this.showActionSummary = false;
  }

  printActionSummary() {
    window.print();
  }

  private buildActionSummary(actions: Action[] = this.actionList?.Actions || []) {
    const actionMap = new Map<number, Action>();
    actions.forEach(a => actionMap.set(a.ActionID, a));
    const isBlank = (value: string | null | undefined) => !value || value.trim().length === 0;
    this.summaryActions = actions.map(a => {
      if (a.ParentActionID > 0) {
        const parent = actionMap.get(a.ParentActionID);
        if (parent) {
          const merged = new Action(a);
          if (isBlank(merged.AuditName) && !isBlank(parent.AuditName)) {
            merged.AuditName = parent.AuditName;
          }
          if (!merged.AuditCompletedDate && parent.AuditCompletedDate) {
            merged.AuditCompletedDate = parent.AuditCompletedDate;
          }
          if (!merged.AuditLocation?.LocationName && parent.AuditLocation?.LocationName) {
            merged.AuditLocation = parent.AuditLocation;
          }
          if (isBlank(merged.QuestionHeader) && !isBlank(parent.QuestionHeader)) {
            merged.QuestionHeader = parent.QuestionHeader;
          }
          if (isBlank(merged.QuestionBody) && !isBlank(parent.QuestionBody)) {
            merged.QuestionBody = parent.QuestionBody;
          }
          if (isBlank(merged.Result) && !isBlank(parent.Result)) {
            merged.Result = parent.Result;
          }
          if (isBlank(merged.Reference) && !isBlank(parent.Reference)) {
            merged.Reference = parent.Reference;
          }
          if (isBlank(merged.ReferenceQuestionHeader) && !isBlank(parent.ReferenceQuestionHeader)) {
            merged.ReferenceQuestionHeader = parent.ReferenceQuestionHeader;
          }
          if (isBlank(merged.ReferenceQuestionBody) && !isBlank(parent.ReferenceQuestionBody)) {
            merged.ReferenceQuestionBody = parent.ReferenceQuestionBody;
          }
          return merged;
        }
      }
      return a;
    });
    this.summaryHasComments = this.summaryActions.some(a => (a.Comments || '').trim().length > 0);
    this.summaryHasReference = this.summaryActions.some(a =>
      (a.Reference || '').trim().length > 0 ||
      (a.ReferenceQuestionHeader || '').trim().length > 0 ||
      (a.ReferenceQuestionBody || '').trim().length > 0
    );
  }

  exportActionList() {
    const exportRequest = new ActionListRequest({ ...this.request, PageNumber: 1, PageSize: 0 });
    this.actionService.getCurrentActions(exportRequest).pipe(
      tap((res: ActionResult) => {
        if (!res.IsError) {
          this.exportService.exportActionList(res.Actions).subscribe();
        }
      })
    ).subscribe();
  }
}
